import { render } from "./IconPlusOutlined.vue?vue&type=template&id=bbc17b14"
import script from "./IconPlusOutlined.vue?vue&type=script&lang=js"
export * from "./IconPlusOutlined.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/20/IconPlusOutlined.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbc17b14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbc17b14', __exports__)) {
    api.reload('bbc17b14', __exports__)
  }
  
  module.hot.accept("./IconPlusOutlined.vue?vue&type=template&id=bbc17b14", () => {
    api.rerender('bbc17b14', render)
  })

}


export default __exports__